<template>
  <div class="value-prop">
    <img class="image-container" :src="require(`@/assets/${valueProp.imageName}`)">
    <div class="page-content">
      <div class="description">
        <div class="title">{{ valueProp.title }}</div>
        <div class="subtitle">{{ valueProp.subtitle }}</div>
      </div>
      <div class="button-container">
        <riseup-button class="next-question" :title="'הבנתי, מצוין'" :action="next" :size="'small'" />
      </div>
    </div>
  </div>
</template>

<script>

import _ from 'lodash';
import BaseUI from 'base-ui';
import valueProps from '../consts/value-props';
import Segment from '../../../../../../Segment';

export default {
  name: 'ValueProp',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  created() {
    Segment.trackUserGot(`ValueProp-${this.componentName}-Entered`, { valuePropIndex: this.valuePropIndex, valuePropName: this.componentName });
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
    componentName: {
      type: String,
      required: true,
    },
  },
  computed: {
    valueProp() {
      return _.find(valueProps.VALUE_PROPS, { name: this.componentName });
    },
    valuePropIndex() {
      return _.findIndex(valueProps.VALUE_PROPS, { name: this.componentName });
    },
  },
  watch: {
    componentName(newVal) {
      if (newVal) {
        Segment.trackUserGot(`ValueProp-${this.componentName}-Entered`, { valuePropIndex: this.valuePropIndex, valuePropName: this.componentName });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../scss/mixins';

  .value-prop {
    @include white-page-frame;
    height: 100%;

    .image-container {
      width: 100%;
    }

    .page-content {
      @include responsive-padding;
      margin-top: 30px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .description {
        .title {
          font-size: 24px;
          line-height: 1.2;
          width: 100%;
          margin-bottom: 12px;
          font-weight: bold,
        }

        .subtitle {
          font-size: 18px;
          line-height: 1.4;
        }
      }

      .button-container {
        @include responsive-padding-top-bottom;

        .next-question {
          width: 100%;
          white-space: nowrap;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/non-authenticated/wine-and-dine/lead-qualification/value-props/ValueProp.vue